import type { FC } from 'react';
import { useCallback, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiData, BuyCoreButtonBiEvent } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DesktopBatchActionWrapper from '../DesktopBatchActionWrapper';
import MobileBatchActionWrapper from '../MobileBatchActionWrapper';
import { BatchActionProps } from '../types';
import ScheduleTimeForm from '@wix/da-submit-shared/pkg/common/ScheduleTimeForm';

export interface Props extends BatchActionProps {
  batchSchedule: (scheduleTs: number) => void;
}

const ScheduleBatch: FC<Props> = ({ batchSchedule, selectionArea }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const [selectedTs, setSelectedTs] = useState<number>();

  const handleSave = useCallback(() => {
    if (selectedTs) {
      batchSchedule(selectedTs);
    }
  }, [batchSchedule, selectedTs]);

  const form = (
    <div>
      <ScheduleTimeForm onChange={setSelectedTs} />
    </div>
  );

  const coreUpgradeBiData = BiData<BuyCoreButtonBiEvent>({
    evid: 375,
    referral_info: ReferralType.STUDIO_BATCH_SCHEDULE,
  });

  if (isMobile) {
    return (
      <MobileBatchActionWrapper
        heading={t('studio.batchActions.subtitle.edit_schedule')}
        disableSave={!selectedTs}
        onSave={handleSave}
        coreUpgradeBiData={coreUpgradeBiData}
        restrictSave="core"
      >
        {form}
      </MobileBatchActionWrapper>
    );
  }
  return (
    <DesktopBatchActionWrapper
      heading={t('studio.batchActions.subtitle.edit_schedule')}
      selectionArea={selectionArea}
      disableSave={!selectedTs}
      onSave={handleSave}
      coreUpgradeBiData={coreUpgradeBiData}
      restrictSave="core"
    >
      {form}
    </DesktopBatchActionWrapper>
  );
};
ScheduleBatch.displayName = 'ScheduleBatch';

export default ScheduleBatch;
